const init = () => {

	document.querySelector('body').classList.add('js-loaded');

	// Global
	navOverlay();
	initPopups();
    numberRoll();
	initAccordions();
	initSelectric();
	initScrollingAnimations();
	bookATable();
	// privateHireVenuesDropdown();
	matchHeight();
	scrollToTop();
	// modularPageExample();
	// Google Maps
	// initSingleLocationMap();
    allSliders();
    lineAnimation('links__item');
    faqsFilter();
    newsFilter(); 
    postcode();
    mailchimp();
    privateEventsFilter();
    homeHero();
    menuFilter();
    form();
    prlx();
    smoothScroll();
    lazyLoadVideo();
};


const areWeUsingBarba = false;

if(areWeUsingBarba){
	// //Fire init function once page is loaded
	window.addEventListener('DOMContentLoaded', (event) => {
		initBarba();
	});

}else{
	$(document).ready(function(){
		init();
	});
}



